export default require("./node_modules/vue-wechat-title/vue-wechat-title.js");